<!-- Flat buttons (filled background) -->
@if (variant === "primary" || variant === "success" || variant === "warning" || variant === "error") {
  <button
    [attr.data-test]="'sg-button-variant_' + variant"
    [attr.aria-label]="ariaLabel"
    [attr.aria-describedby]="description ? descriptionId : null"
    type="button"
    mat-flat-button
    disableRipple
    class="sg-ui-component"
    [ngClass]="buttonInternalClasses"
    [class]="cssClass || ''"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="disabledInteractive"
    (click)="onButtonClick()">
    @if (isIconButton) {
      <ng-container *ngTemplateOutlet="iconButton"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
      <div class="sg-button-content" [ngClass]="{ 'sg-hidden': isLoading }">
        @if (icon && iconPosition === "start") {
          <mat-icon [ngClass]="classPrefix + iconPosition" class="sg-ui-component">{{ icon }}</mat-icon>
        }
        <ng-container *ngTemplateOutlet="labelOrContent"></ng-container>
        @if (icon && iconPosition === "end") {
          <mat-icon [ngClass]="classPrefix + iconPosition" class="sg-ui-component">{{ icon }}</mat-icon>
        }
      </div>
    }
  </button>
}
<!-- Stroked buttons (with border) -->
@if (["secondary", "secondary-on-color", "neutral"].includes(variant)) {
  <button
    [attr.data-test]="'sg-button-variant_' + variant"
    [attr.aria-label]="ariaLabel"
    [attr.aria-describedby]="description ? descriptionId : null"
    mat-stroked-button
    type="button"
    disableRipple
    class="sg-ui-component"
    [ngClass]="buttonInternalClasses"
    [class]="cssClass || ''"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="disabledInteractive"
    (click)="onButtonClick()">
    @if (isIconButton) {
      <ng-container *ngTemplateOutlet="iconButton"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
      <div class="sg-button-content" [ngClass]="{ 'sg-hidden': isLoading }">
        @if (icon && iconPosition === "start") {
          <mat-icon [ngClass]="classPrefix + iconPosition" class="sg-ui-component">{{ icon }}</mat-icon>
        }
        <ng-container *ngTemplateOutlet="labelOrContent"></ng-container>
        @if (icon && iconPosition === "end") {
          <mat-icon [ngClass]="classPrefix + iconPosition" class="sg-ui-component">{{ icon }}</mat-icon>
        }
      </div>
    }
  </button>
}
<!-- Ghost buttons (no border or background) -->
@if (["ghost-primary", "ghost-secondary", "ghost-secondary-on-color"].includes(variant)) {
  <button
    [attr.data-test]="'sg-button-variant_' + variant"
    [attr.aria-label]="ariaLabel"
    [attr.aria-describedby]="description ? descriptionId : null"
    mat-button
    type="button"
    disableRipple
    class="sg-ui-component"
    [ngClass]="buttonInternalClasses"
    [class]="cssClass || ''"
    [disabled]="disabled || isLoading"
    [disabledInteractive]="disabledInteractive"
    (click)="onButtonClick()">
    @if (isIconButton) {
      <ng-container *ngTemplateOutlet="iconButton"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
      <div class="sg-button-content" [ngClass]="{ 'sg-hidden': isLoading }">
        @if (icon && iconPosition === "start") {
          <mat-icon [ngClass]="classPrefix + iconPosition" class="sg-ui-component">{{ icon }}</mat-icon>
        }
        <ng-container *ngTemplateOutlet="labelOrContent"></ng-container>
        @if (icon && iconPosition === "end") {
          <mat-icon [ngClass]="classPrefix + iconPosition" class="sg-ui-component">{{ icon }}</mat-icon>
        }
      </div>
    }
  </button>
}
@if (description) {
  <sg-text class="sg-button-description" variant="sg-body-small-regular" [attr.id]="descriptionId" data-test="sg-button-description">{{ description }}</sg-text>
}
<ng-template #loader>
  @if (isLoading) {
    <div class="sg-progress-indication">
      <div class="bullet"></div>
      <div class="bullet"></div>
      <div class="bullet"></div>
    </div>
  }
</ng-template>
<ng-template #iconButton>
  <ng-container *ngTemplateOutlet="loader"></ng-container>
  @if (!isLoading) {
    <mat-icon class="sg-ui-component">{{ icon }}</mat-icon>
  }
</ng-template>
<ng-template #labelOrContent>
  @if (text) {
    <sg-text
      [variant]="size === 'small' ? 'sg-label-small-regular' : size === 'medium' ? 'sg-label-medium-regular' : 'sg-label-large-regular'"
      withoutLineHeight="true">
      {{ text }}
    </sg-text>
  } @else {
    <ng-content></ng-content>
  }
</ng-template>
